<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="1200_auto"
      not-footer-padding
  >
    <template #header>联系买家</template>
    <template #content>
      <div style=" font-size: 12px" v-loading="initReasonLoad" element-loading-text="正在获取亚马逊可选原因">
        <gj-area-title>选择联系买家原因</gj-area-title>
        <div style="padding: 8px 0 0 0">
          <el-radio-group v-model="reason" class="contact-buyer">
            <el-radio :label="'confirmOrderDetails'" :disabled="reasonList.indexOf('confirmOrderDetails') === -1">
              <span class="color444">确认订单详情</span><gj-button size="mini" class="gj-ml5" v-show="orderNumber > 0 ? true : false">{{orderNumber}}</gj-button>
              <div class="mtp-10 color666">请在发货之前询问客户特定的订单相关问题</div>
            </el-radio>
            <el-radio :label="'confirmDeliveryDetails'" :disabled="reasonList.indexOf('confirmDeliveryDetails') === -1">
              <span class="color444">协调大件或重型商品的配送</span><gj-button size="mini" class="gj-ml5" v-show="deliverNumber > 0 ? true : false">{{deliverNumber}}</gj-button>
              <div class="mtp-10 color666">联系您的买家以安排订单配送或确认完成配送所需的详细联系方式</div>
            </el-radio>
            <el-radio :label="'unexpectedProblem'" :disabled="reasonList.indexOf('unexpectedProblem') === -1">
              <span class="color444">通知配送订单存在问题</span><gj-button size="mini" class="gj-ml5" v-show="uexpectNumber > 0 ? true : false">{{uexpectNumber}}</gj-button>
              <div class="mtp-10 color666">通知买家在配送其订单时出现意外问题</div>
            </el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top: 20px">
          <div class="completion-message">
            <gj-area-title style="margin-right: 40px; margin-top: 5px">完整消息</gj-area-title>
            <gj-select
              v-model="emailType"
              placeholder="选择模板类型"
              :options="templateTypeOptions"
              width="132px"
              key="选择模板类型"
              >
            </gj-select>
            <gj-select
              v-model="selectMailTemplate"
              placeholder="选择回复模板"
              :options="showTemplateList"
              style="margin-left: 10px;"
              width="200px"
              key="选择回复模板"
              >
            </gj-select>
          </div>
          <div>
            <div class="gj-mb10">
              在下面的框中输入您的消息。我们会将其转发至买家。请不要在您的消息中包含HTML或者链接(URL)。如果您需要咨询某个特定订单或商品相关的问题，请在邮件中包含订单号，商品名称和/或ASIN/ISBN
            </div>
            <gj-textarea
              v-model="desc"
              :styles="{height: '289px'}"
              placeholder="字符数上限：4000个。仅允许使用与完成订单相关的链接，不得使用HTML或电子邮件地址。"
              maxlength="4000"
              show-word-limit
            ></gj-textarea>
            <div v-show="false">
              <gj-wang-editor
                ref="gjWangEditor"
                v-model="descTwo"
                :maxLength="4000"
                height="289">
              </gj-wang-editor>
            </div>
          </div>
          <div class="gj-mtb8 color333 flex justify-between">
            买家首先语言：{{preferredLanguage}}
            <gj-button @click="clearFormat">清除格式</gj-button>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button @click="confirm" type="primary" :disabled="reason === null" :loading="loading">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {getContactBuyerReasons} from "../../../../../api/sale";
  import GjWangEditor from '@/components/wang-editor/gj-wang-editor.vue'
  import {  getTemplateType, getMailTemplateList} from "../../../../../api/crm"
  export default {
    name: "sale-order-contact-buyer",
    mixins: [modalMixIn],
    components: { GjWangEditor },
    props: {
      id: null,
      marketId: null
    },
    created() {
      getContactBuyerReasons(this.id)
        .then((data) => {
          this.reasonList = data.reasons;
          this.contactNumList = data.contactNum;
          this.preferredLanguage = data.preferredLanguage;
          if (data.contactNum.length > 0) {
            this.contactNumList.forEach(v=>{
                if (v.buyerReasons === "confirmOrderDetails") {
                  this.orderNumber = v.totalNum
                }

                if (v.buyerReasons === "confirmDeliveryDetails") {
                  this.deliverNumber = v.totalNum
                }

                if (v.buyerReasons === "unexpectedProblem") {
                  this.uexpectNumber = v.totalNum
                }
            })
          }
        })
        .complete(() => this.initReasonLoad = false)
      //模版类型
      getTemplateType()
            .then((res) => {
              this.templateTypeOptions = res.data
              
            })
            .complete();
      //回复模版列表
      let markList = this.marketId ? [this.marketId] : [];
      let params = {
        countryCodeList: [],
        marketIdList: markList
      }
      getMailTemplateList(params).then((res) => {
          this.mailTemplateList = res.data;
          
      }).complete(() => {
        this.getShowTemplate("");
      }
        
      );
    
    },
    data() {
      return {
        reason: null,
        desc: null,
        descTwo: null,
        reasonList: [],
        contactNumList: [],
        preferredLanguage: "",
        orderNumber: 0,
        deliverNumber: 0,
        uexpectNumber: 0,
        emailType: null,
        mailTemplateList: [],
        showTemplateList: [],
        selectMailTemplate: null,
        initReasonLoad: true,
        loading: false,
        filter: {
          type: null,
          templateId: null
        },
        templateTypeOptions: [
          {text: 'request a review', id: 1},
          {text: '节假日自动回复', id: 2},
          {text: '差评关怀', id: 3},
          {text: '退款关怀', id: 4},
          {text: '邀评', id: 5},
          {text: '自定义类型', id: 6}
        ],
        mailTemplateOption: [
          {text: '654', id: 1},
          {text: '123', id: 2}
        ]
      }
    },
    watch: {
          emailType(val) {
              this.getShowTemplate(val)
              this.selectMailTemplate = null
          },
          selectMailTemplate(val) {
            if(val) {
              let item = this.showTemplateList.find((res) =>
                res.id === val
              );
              this.desc = item.content
              let  index = item.content.indexOf("<p>")
              if(index > -1) {
                this.descTwo = item.content
              } else {
                this.descTwo = item.content.split(/\n/).map(line => `<p>${line}</p>`).join('\n')
              }
            }
          }
      },
    methods: {
      clearFormat() {
        if(this.desc) {
          this.desc = this.desc.replace(/\n/g, '__GERP_GO__');
          setTimeout(() => {
              const quillText = this.$refs.gjWangEditor.getText().replace(/\n$/, '');
              this.desc = quillText.replace(/__GERP_GO__/g, '\n');
          });
        }
      },
      confirm() {
        this.$emit('contactBuyer', {content: this.desc, reason: this.reason})
      },
      getShowTemplate(mailType){
        var showList = [];
        if (mailType.length > 0) {
            this.mailTemplateList.forEach((res) => {
                          let voList = res.marketMailTemplateVOList;
                          if (res.templateTypeId == mailType) {
                             voList.forEach((item) => {
                                let info = {
                                  id: item.id,
                                  text: item.name,
                                  content: item.content
                                }
                                showList.push(info)
                            })
                          }
                    })
        } else {
            this.mailTemplateList.forEach((res) => {
                  let voList = res.marketMailTemplateVOList;
                  voList.forEach((item) => {
                      let info = {
                        id: item.id,
                        text: item.name,
                        content: item.content
                      }
                      showList.push(info)
                  })
            })
        }
        this.showTemplateList = showList;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .contact-buyer {
  }

  .contact-buyer /deep/ .el-radio {
    color: #606266;
    font-weight: 500;
    line-height: 1;
    position: relative;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    font-size: 14px;
    margin-right: 80px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  .completion-message {
    display: flex;
    flex-direction: row;

  }
  .mtp-10 {
    margin-top: 10px;
  }

  .color444 {
    color: #333;
  }

  .color666 {
    color: #666;
    padding-left: 22px;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }

  .contact-buyer {
    /deep/ .el-button--mini {
      padding: 2px 6px;
      background: #8080ff;
      border: 1px solid #8080ff;
      color: #FFFFFF;
    }
  }
</style>
